import { render, staticRenderFns } from "./layout-body.vue?vue&type=template&id=c5a29b58&scoped=true&"
import script from "./layout-body.vue?vue&type=script&lang=js&"
export * from "./layout-body.vue?vue&type=script&lang=js&"
import style0 from "./layout-body.vue?vue&type=style&index=0&id=c5a29b58&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a29b58",
  null
  
)

export default component.exports